import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Util } from '@grandvisionhq/forms';
import { parseHtml } from '@grandvisionhq/lib-utils-html';
import { useIntl } from '@grandvisionhq/state';
import CheckboxField from './CheckboxField/CheckboxField.js';

const labelOptions = {
    parseHTML: false,
    parseLink: true,
    openLinksInNewTab: true
};
const Consent = (_param)=>{
    var { className , errorMessage , consents  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "errorMessage",
        "consents"
    ]);
    const { getFormattedLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('consent', className)
    }), consents.map((consent)=>/*#__PURE__*/ React.createElement("li", {
            key: consent.title,
            className: "consent__consent"
        }, /*#__PURE__*/ React.createElement(CheckboxField, {
            name: consent.value,
            label: /*#__PURE__*/ React.createElement(React.Fragment, null, parseHtml(getFormattedLabel(consent.title, labelOptions))),
            "aria-label": consent.ariaLabel,
            error: errorMessage,
            required: true,
            validations: [
                Util.validations.isRequired
            ],
            "data-t": consent.value
        }))
    ));
};

export { Consent as default };
//# sourceMappingURL=Consent.js.map
